import { Card, CardContent, CardHeader, CardTitle } from "@/components/uiDir/card";
import { Eye, Heart, Users, FolderOpen, TrendingUp, ArrowUpRight } from "lucide-react";
import { DashboardStatsProps } from "@/lib/models/dashboardstatsModel";

export function DashboardStats({ 
  profileViews = 0, 
  totalLikes = 0, 
  followersCount = 0, 
  projectsCount = 0 
}: DashboardStatsProps) {
  const stats = [
    {
      title: "Profile Views",
      value: profileViews.toLocaleString(),
      icon: Eye,
      trend: "+12%",
      trendUp: true,
      color: "text-blue-500",
      bgColor: "bg-blue-500/10",
    },
    {
      title: "Total Likes",
      value: totalLikes.toLocaleString(),
      icon: Heart,
      trend: "+8%",
      trendUp: true,
      color: "text-pink-500",
      bgColor: "bg-pink-500/10",
    },
    {
      title: "Followers",
      value: followersCount.toLocaleString(),
      icon: Users,
      trend: "+23%",
      trendUp: true,
      color: "text-purple-500",
      bgColor: "bg-purple-500/10",
    },
    {
      title: "Projects",
      value: projectsCount.toLocaleString(),
      icon: FolderOpen,
      trend: "—",
      trendUp: false,
      color: "text-green-500",
      bgColor: "bg-green-500/10",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, index) => (
        <Card 
          key={stat.title} 
          className="glass-card hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
          style={{ animationDelay: `${index * 50}ms` }}
        >
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              {stat.title}
            </CardTitle>
            <div className={`p-2 rounded-lg ${stat.bgColor}`}>
              <stat.icon className={`h-4 w-4 ${stat.color}`} />
            </div>
          </CardHeader>
          <CardContent>
            <div className="flex items-end justify-between">
              <div>
                <div className="text-3xl font-bold font-heading">{stat.value}</div>
                <div className="flex items-center gap-1 mt-1 text-xs">
                  {stat.trendUp ? (
                    <>
                      <TrendingUp className="h-3 w-3 text-green-500" />
                      <span className="text-green-500 font-medium">{stat.trend}</span>
                    </>
                  ) : (
                    <span className="text-muted-foreground">{stat.trend}</span>
                  )}
                  <span className="text-muted-foreground">this month</span>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}